export default "__VITE_ASSET__711qzq4X__"